import { useSelector } from 'react-redux';

import { useActions } from '@mssgme/hooks';
import { getConversation } from '@mssgme/store';

export default function useMessagesHeader(contactId) {
    const { api } = useActions();
    const { isArchivedConversation, contact } = useSelector((state) => {
        const { status, contact } = getConversation(state, contactId);

        return {
            isArchivedConversation: status === 'close',
            contact,
        };
    });

    const onArchiveToggle = (e) => {
        e.preventDefault();
        api.conversations.changeStatus({ contactId, status: isArchivedConversation ? 'open' : 'close' });
    };

    return { isArchivedConversation, contact, onArchiveToggle };
}
